import {
  AddStripeBasilJsTag,
  getStripeSessionURL,
  getStripeClientConfigURL  } from "./stripePayment";
import { DonationForm } from "../donation/donationForm";

import { translateText, getLocale, initializeLanguageSettings } from "../internationalization";
import { fcbhCredentials, removeFcbhCredentials, getRedirectUrlByStatusAndOutreach } from "../payment";
import { fetchWithCredentials, postWithCredentials, saveFormCampaignGIVE_FORM } from "../helpers";

export class StripePaymentElement {
    stripe;
    element;
    donationForm;
    oneTimePay;
    firstNameElId;
    lastNameElId;
    address1ElId;
    address2ElId;
    cityElId;
    stateElId;
    regionElId;
    zipElId;
    countryElId;
    emailElId;
    phoneNumberElId;
    minAmount;
    translations;
    authData = {
      apiKey: null
    };

   constructor(donationForm,
        {firstNameElId, lastNameElId,
        address1ElId, address2ElId, cityElId, stateElId, regionElId, zipElId, countryElId,
        emailElId, phoneNumberElId}) {

        this.donationForm = donationForm instanceof DonationForm ? donationForm : null;

        const isRecurring = this.donationForm.donationType?.toLowerCase() === 'yes' || this.donationForm.donationType?.toLowerCase() === 'monthly' ;
        this.oneTimePay = !isRecurring;
        this.firstNameElId = firstNameElId;
        this.lastNameElId= lastNameElId;
        this.address1ElId = address1ElId;
        this.address2ElId = address2ElId;
        this.cityElId = cityElId;
        this.stateElId = stateElId;
        this.regionElId = regionElId;
        this.zipElId = zipElId;
        this.countryElId = countryElId;
        this.emailElId = emailElId;
        this.phoneNumberElId = phoneNumberElId;
        this.writeScript();
        this.mountStripeElements();
        this.prepareEventListeners();
    }

    writeScript() {
       this.script = AddStripeBasilJsTag();
       
      this.translations = initializeLanguageSettings().then((res) => {
        this.translations = res;
      });
    }

    prepareEventListeners() {

      document.getElementById(this.lastNameElId).addEventListener("input", () => this.updatePaymentElement(this.donationForm));
      document.getElementById(this.firstNameElId).addEventListener("input", () => this.updatePaymentElement(this.donationForm));
      document.getElementById(this.address1ElId).addEventListener("input", () => this.updatePaymentElement(this.donationForm));
      document.getElementById(this.address2ElId).addEventListener("input", () => this.updatePaymentElement(this.donationForm));
      document.getElementById(this.cityElId).addEventListener("input", () => this.updatePaymentElement(this.donationForm));
      document.getElementById(this.stateElId).addEventListener("input", () => this.updatePaymentElement(this.donationForm));
      document.getElementById(this.regionElId)?.addEventListener("input", () => this.updatePaymentElement(this.donationForm));
      document.getElementById(this.zipElId).addEventListener("input", () => this.updatePaymentElement(this.donationForm));
      document.getElementById(this.countryElId).addEventListener("input", () => this.updatePaymentElement(this.donationForm));
      document.getElementById(this.emailElId).addEventListener("input", () => this.updatePaymentElement(this.donationForm));
      document.getElementById(this.phoneNumberElId).addEventListener("input", () => this.updatePaymentElement(this.donationForm));
    }

    updatePaymentElement(donationForm = this.donationForm) {
        const formData = new FormData(donationForm.form);
        const isRecurring = this.donationForm.donationType?.toLowerCase() === 'yes' || this.donationForm.donationType?.toLowerCase() === 'monthly' ;
        this.oneTimePay = !isRecurring;
        var amount = this.donationForm.getLocalAmount() == 0? 5 : this.donationForm.getLocalAmount();

        const options = {
          mode: this.oneTimePay? 'payment':'subscription',
          amount: parseInt(parseFloat(amount)?.toFixed(2) * 100),
          currency: this.donationForm.getLocalCurrency()?.toLowerCase()
        };
        this.elements.update(options);
        const paymentElement = this.elements.getElement('payment');
        if (paymentElement) {
          paymentElement.update({
          defaultValues: {
            billingDetails: {
              name: `${formData.get(this.firstNameElId)} ${formData.get(this.lastNameElId)}`,
              address: {
                line1: formData.get(this.address1ElId),
                line2: formData.get(this.address2ElId),
                city: formData.get(this.cityElId),
                state: formData.get(this.countryElId) === "US" ? formData.get(this.stateElId): formData.get(this.regionElId),
                postal_code: formData.get(this.zipElId),
                country: formData.get(this.countryElId)
              },
              email: formData.get(this.emailElId),
              phone: formData.get(this.phoneNumberElId)?.replace(/\s/g, '').slice(-10),
            }
          }
          });
        }
    }

    async mountStripeElements() {

      var apiKey = await fcbhCredentials();
      this.authData.apiKey = apiKey;

      const config = await fetchWithCredentials(
        getStripeClientConfigURL(),
        this.authData.apiKey
      );

      const { publishableKey, minAmount} = config.data;
      this.minAmount = minAmount?? 3;

      this.stripe = Stripe(publishableKey);
      var amount = isNaN(this.donationForm.getLocalAmount()) || this.donationForm.getLocalAmount() == 0? 5 : this.donationForm.getLocalAmount();

      const options = {
         mode: this.oneTimePay? 'payment':'subscription',
         amount: parseInt(parseFloat(amount)?.toFixed(2) * 100),
         currency: this.donationForm?.getLocalCurrency()?.toLowerCase(),
         layout: 'accordion',
         locale: getLocale() || 'auto',
      };
      this.elements = this.stripe.elements( options);

      // Create and mount the Payment Element
      const paymentElementOptions = { layout: 'accordion'};
      const paymentElement = this.elements.create('payment', paymentElementOptions);
      paymentElement.mount('#payment-element');
    }

    async processStripePayment(formStruct) {
      // Trigger form validation and wallet collection
      let cresponse = this.donationForm.donateReCaptcha ? 
        (this.donationForm.captchaWidgetId !== '' ? grecaptcha.getResponse(this.donationForm.captchaWidgetId) : grecaptcha.getResponse())
        : [];

      if (cresponse.length == 0) { 
        return;
      }
      const {error: submitError} = await this.elements.submit();
      if (submitError) {
        console.log("submitError", submitError);
        this.showErrorWithMessage(submitError.message);
        return;
      }
      
      let resp;

      if (this.oneTimePay === true) {
        resp = await postWithCredentials(
          getStripeSessionURL('createPaymentIntent'),
          this.getFormToSend(formStruct), this.authData.apiKey
        );
      } else {
        var urlType = this.donationForm.isUpgrade? "upgrade" : "createSubscription";
        resp = await postWithCredentials(
          getStripeSessionURL(urlType),
          this.getFormToSend(formStruct), this.authData.apiKey
        );
        
      }
      saveFormCampaignGIVE_FORM(this.donationForm.formCampaign.localForm);
      
      const {type, clientSecret} = await resp.data;
      var elements = this.elements;
      var confirmIntent = type === "setup" ? this.stripe.confirmSetup : this.stripe.confirmPayment;
      const {error} = await confirmIntent({
        elements,
        clientSecret,
        confirmParams: {
          return_url: `${window.location.origin}${getRedirectUrlByStatusAndOutreach("success", formStruct.outreach)}`
        },
      });
      removeFcbhCredentials();
      if (error) {
        console.log("error", error);
        // This point is only reached if there's an immediate error when
        // confirming the payment. Show the error to your customer (for example, payment details incomplete)
        this.showErrorWithMessage(error.message);
      }
    }

    showErrorWithMessage(messages) {
      let message;
      let messagePrefix = translateText("give.address_error",this.translations);
      if (Array.isArray(messages)) {
        message = `${messagePrefix}<br/>${messages.join("<br/>")}`;
      } else {
        message = messages;
      }
      this.donationForm.errorBlockEl.querySelector("div").innerHTML = message;
      this.donationForm.errorBlockEl.style.display = "block";
      window.scrollTo(0, this.donationForm.errorBlockEl.offsetTop - 150);
    }

    getFormToSend(formStruct) {
      const formToSend = new FormData();

      for (const key in formStruct) {
        formToSend.append(key, formStruct[key]);
      }
      return formToSend;
    }
}